(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ocorrencia', {
            parent: 'entity',
            url: '/ocorrencia?page&sort&search',
            data: {
                authorities: ['ROLE_OCORRENCIA_CHAMADO'],
                pageTitle: 'chamadosApp.ocorrencia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ocorrencia/ocorrencia.html',
                    controller: 'OcorrenciaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ocorrencia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ocorrencia.new', {
            parent: 'ocorrencia',
            url: '/new',
            data: {
                authorities: ['ROLE_OCORRENCIA_CHAMADO']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ocorrencia/ocorrencia-dialog.html',
                    controller: 'OcorrenciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                url: null,
                                id: null,
                                cliente: null,
                                sistema: null,
                                ocorrencias: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ocorrencia', null, { reload: 'ocorrencia' });
                }, function() {
                    $state.go('ocorrencia');
                });
            }]
        })
        .state('ocorrencia.edit', {
            parent: 'ocorrencia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_OCORRENCIA_CHAMADO']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ocorrencia/ocorrencia-dialog.html',
                    controller: 'OcorrenciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ocorrencia', function(Ocorrencia) {
                            return Ocorrencia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ocorrencia', null, { reload: 'ocorrencia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();
